import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import Dependency from '../Licensing/Dependency';
import FileMatches from '../Licensing/FileMatches';
import Footer from '../Licensing/Footer';
import Header from '../Licensing/Header';
import IssueDetails from '../Licensing/IssueDetails';
import Licenses from '../Licensing/Licenses';
import IssueDetailsResolvedReason from '../ResolvedReason';
import type { IssueDetailsTab } from '../Tabs';

import IssueGenericContent from './IssueGenericContent';
import LicensingIssueLoading from './Loading/LicensingIssueLoading';

type LicensingIssueDrawerContentProps = {
  activeTab: IssueDetailsTab;
  setActiveTab: (tab: IssueDetailsTab) => void;
};

const LicensingIssueContent: VoidFunctionComponent<LicensingIssueDrawerContentProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const isLoadingIssueDetails = useSelector(IssuesV2Store.selectors.getIsLoadingIssueDetails);

  if (isLoadingIssueDetails) {
    return <LicensingIssueLoading />;
  }

  return (
    <IssueGenericContent
      headerSlot={<Header />}
      contentSlot={(
        <>
          <IssueDetailsResolvedReason />
          <IssueDetails />
          <FileMatches />
          <Licenses />
          <Dependency />
          <Footer />
        </>
      )}
      setActiveTab={setActiveTab}
      activeTab={activeTab}
    />
  );
};

export default LicensingIssueContent;
